import { render, staticRenderFns } from "./device_pending.vue?vue&type=template&id=270fef64"
import script from "./device_pending.vue?vue&type=script&lang=js"
export * from "./device_pending.vue?vue&type=script&lang=js"
import style0 from "./device_pending.vue?vue&type=style&index=0&id=270fef64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports